export const useCases = [
  {
    slug: 'weddings',
    title: 'Weddings',
    badge: 'Ceremony + receptions',
    icon: '💍',
    bg: '#fff5f8',
    copy: 'Modern invites, transparent vendor quotes, and guest-friendly timelines for every event in the weekend.',
    points: [
      'Reusable looks for rehearsal dinners, ceremonies, and after-parties',
      'Seat mapping and RSVP caps to keep guest flow smooth',
      'Concierge vendor swaps if plans change last minute'
    ],
    howItWorks: [
      'Pick a design for each event (rehearsal, ceremony, after-party) and sync RSVPs across them.',
      'Share venue maps, hotel blocks, and shuttle timing in one link.',
      'Request vendor holds (photo, video, decor) and sign in a single dashboard.'
    ],
    benefits: [
      'No more fragmented invites—guests always see the latest plan.',
      'Transparent pricing keeps budgets on track.',
      'Fast concierge support for backup vendors and rain plans.'
    ]
  },
  {
    slug: 'private-events',
    title: 'Private Events',
    badge: 'Birthdays & gatherings',
    icon: '🎉',
    bg: '#fff9f2',
    copy: 'Design-forward invites for birthdays, anniversaries, and intimate dinners that still feel premium.',
    points: [
      'Collect RSVPs and dietary notes in one place',
      'Line up private chefs, bartenders, or decor in minutes',
      'Send updates over SMS or email automatically'
    ],
    howItWorks: [
      'Choose a post, GIF, or custom upload and drop in your details.',
      'Add co-hosts to help manage RSVPs and guest messages.',
      'Book decor, catering, and entertainment directly from vetted partners.'
    ],
    benefits: [
      'Less back-and-forth on details and allergies.',
      'Looks great on social while staying on-brand for you.',
      'Trusted vendors make setup effortless.'
    ]
  },
  {
    slug: 'college-events',
    title: 'College Events',
    badge: 'Campus life',
    icon: '🎓',
    bg: '#f3f8ff',
    copy: 'Host orientations, club nights, hackathons, and alumni mixers with shareable, mobile-first invites.',
    points: [
      'Link signups to capacity tracking and waitlists',
      'Add sponsors, performers, and AV with vetted vendors',
      'QR codes for door check-ins and rapid guest exports'
    ],
    howItWorks: [
      'Publish invites as posts or GIFs and share across student channels.',
      'Enable waitlists and caps, then export RSVPs for check-in.',
      'Attach staging, AV, and security vendors with campus-friendly rates.'
    ],
    benefits: [
      'Avoid overcrowding with smart capacity tools.',
      'Keep sponsors visible and deliver on brand guidelines.',
      'Day-of check-ins run smoothly with QR exports.'
    ]
  },
  {
    slug: 'sporting-events',
    title: 'Sporting Events',
    badge: 'Teams & fans',
    icon: '🏈',
    bg: '#f5fff5',
    copy: 'From watch parties to tournament days, keep athletes, staff, and fans aligned with clear schedules.',
    points: [
      'Segment invites for VIP, teams, volunteers, and attendees',
      'Book staging, lighting, and live-stream crews fast',
      'Push timing changes instantly across all guests'
    ],
    howItWorks: [
      'Create separate invites for teams, VIPs, and fans with tailored info.',
      'Sync practice times, call times, and run-of-show in one link.',
      'Coordinate AV, streaming, and staging with vetted vendors.'
    ],
    benefits: [
      'No missed updates—everyone gets the right schedule.',
      'Professional production without the scramble.',
      'Easy to duplicate for the next game or season.'
    ]
  },
  {
    slug: 'social-clubs',
    title: 'Social Clubs',
    badge: 'Communities',
    icon: '🤝',
    bg: '#f5f5ff',
    copy: 'Manage recurring meetups and special drops with branded invites that keep members excited.',
    points: [
      'Template and duplicate monthly events with one click',
      'Membership-friendly RSVPs and guest tagging',
      'Automated reminders to reduce no-shows'
    ],
    howItWorks: [
      'Pick a recurring invite template and duplicate it for each meetup.',
      'Tag member tiers and plus-ones with clear RSVP limits.',
      'Automate reminders and publish updates across channels.'
    ],
    benefits: [
      'Consistent look and feel for your community.',
      'Fewer no-shows with smart reminders.',
      'Repeat events take minutes, not hours.'
    ]
  },
  {
    slug: 'corporate-events',
    title: 'Corporate Events',
    badge: 'Offsites & launches',
    icon: '🏢',
    bg: '#f7fbff',
    copy: 'Give your team launch-ready invites, vendor holds, and run-of-show clarity for summits and roadshows.',
    points: [
      'Lock brand colors and fonts across every template',
      'Collect travel details and preferences with RSVPs',
      'Source venues, AV, and hospitality in one dashboard'
    ],
    howItWorks: [
      'Start from an approved template with locked brand styles.',
      'Add travel fields to RSVPs and export itineraries for ops.',
      'Request venue, AV, and catering quotes with transparent pricing.'
    ],
    benefits: [
      'On-brand every time with no design drift.',
      'Ops teams get clean data for logistics.',
      'Faster vendor decisions with clear comparables.'
    ]
  },
  {
    slug: 'lounges-hotels',
    title: 'Lounges or Hotels',
    badge: 'Hospitality',
    icon: '🛎️',
    bg: '#fffaf2',
    copy: 'Promote weekly programming, VIP drops, or property events while keeping brand standards intact.',
    points: [
      'On-brand flyers and invites that publish in minutes',
      'Integrate table minimums, ticketing links, or room blocks',
      'Share run-sheets with staff and vendors automatically'
    ],
    howItWorks: [
      'Select a hospitality template and add table mins or ticket links.',
      'Segment VIPs, partners, and general guests with tailored details.',
      'Export run-sheets for staff with setup, AV, and timing.'
    ],
    benefits: [
      'Protect your brand while moving fast.',
      'Clear expectations for guests and staff.',
      'Easy to scale weekly programming without rebuilding invites.'
    ]
  }
]

export const getUseCaseBySlug = (slug) => useCases.find(caseItem => caseItem.slug === slug)
